import _ from 'lodash';
import { getCartContentsCount } from '../api/store-api';
import Component from '../classes/component';

const SELECTORS = {
  count: '.cart-count',
};

class CartCount extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _udpateView(count: number) {
    this.container.removeChild(this._getChild('count'));
    const newCount = document.createElement('div');
    newCount.className = 'cart-count shake';
    newCount.innerText = count.toString();
    this.container.appendChild(newCount);
  }

  public async updateCount(count?: number) {
    if (_.isNumber(count)) {
      this._udpateView(count);
    } else {
      const res = await getCartContentsCount();
      if (res.success) this._udpateView(res.data);
    }
  }
}

export default CartCount;
